/*
 * Página de produto: seletor de quantidade e barra fixa de compra.
 *
 * Nada aqui é essencial. O campo de quantidade é um input number que o
 * formulário envia sozinho; os botões − e + e a barra fixa são conveniência.
 * Se este arquivo falhar, a página continua vendendo.
 */
(function () {
  'use strict';

  /* ---------- Quantidade: − e + somam no campo, nunca abaixo de 1 ---------- */
  function ligarQuantidade() {
    var campo = document.querySelector('[data-yasy-qtd]');
    if (!campo) return;

    var botoes = document.querySelectorAll('[data-yasy-qtd-passo]');
    Array.prototype.forEach.call(botoes, function (botao) {
      botao.addEventListener('click', function () {
        var passo = parseInt(botao.getAttribute('data-yasy-qtd-passo'), 10) || 0;
        var atual = parseInt(campo.value, 10) || 1;
        campo.value = Math.max(1, atual + passo);
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Barra fixa: aparece quando o botão principal sai de cena ---------- */
  function ligarBarra() {
    var barra = document.querySelector('[data-yasy-barra]');
    if (!barra) return;

    var ancora = document.getElementById('yasy-form-compra');
    if (!ancora) return;

    function mostrar(sim) {
      barra.classList.toggle('is-visivel', sim);
      barra.setAttribute('aria-hidden', sim ? 'false' : 'true');
    }

    if (typeof IntersectionObserver === 'undefined') return;

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        /* Sempre que o botão principal não está na tela, abaixo (celular, onde
           a galeria vem antes) ou acima (depois de rolar), a barra mostra o
           "Comprar": o botão de compra fica visível desde a primeira dobra. */
        mostrar(!entrada.isIntersecting);
      });
    }, { threshold: 0 });

    observador.observe(ancora);

    /* Conferência direta depois do carregamento: não depende do primeiro
       aviso do observer, que pode chegar antes de a galeria ocupar espaço. */
    function conferir() {
      var r = ancora.getBoundingClientRect();
      mostrar(!(r.top < window.innerHeight && r.bottom > 0));
    }
    if (document.readyState === 'complete') conferir();
    else window.addEventListener('load', conferir, { once: true });
  }

  function iniciar() {
    ligarQuantidade();
    ligarBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
